exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".character__window {\n  position: absolute;\n  top: 20px;\n  padding: 10px 20px;\n  border-radius: 20px;\n  background-color: white; }\n\n.character__name {\n  text-align: center;\n  margin-bottom: 5px; }\n", ""]);

